import { Injectable } from "@angular/core";
import { HttpRequest} from "@angular/common/http";
import { COMMON_CONSTANTS } from "../common/core/common.constants";
import { HttpCacheService } from "./http-cache.service";
import * as _ from "lodash";
import { isNullOrUndefined } from 'src/app/services/utils';
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class SplunkUtilityService {
  requestDate: any;
  b2bRequestid: any;

  constructor(  private _cacheSvc: HttpCacheService,  private _LoggerService: LoggerService ) {} 
  logInSplunk(  req: any, message: any, errorType?: any) {
    let pattern = COMMON_CONSTANTS.REGEX500RANGE;
    let pattern4xx = COMMON_CONSTANTS.REGEX400RANGE;
    if (pattern.test(message.status) || pattern4xx.test(message.status) ||  [COMMON_CONSTANTS.SPLUNK_CLIENTSIDE_ERROR,COMMON_CONSTANTS.HIT_A_SNAG].includes(errorType)) {
      if (!req.url.includes("log-in-splunk")) {
        this.setLogger(req, message, errorType);  
      }   
    }
  }

  setLogger(req, message, errorType) {
    if (isNullOrUndefined(errorType)) {
      this.callsWhenError(message);
      this.callsWhenIsArray(message);

      const urlProps = this._prepareUrlProperties(req);
 
      message = {
        ...message,
        requestBody: req.body,
        responseHeader: message.HttpHeaders,
        api: urlProps["apiName"] || "",
        submitCall: urlProps["submitCall"] || false,
        redFlag: urlProps["RedFlag"] || false,
        flowType: urlProps["flowType"] || "notMentioned",
        apiName: urlProps["apiName"] || "",
        b2brequestid:  message.headers.headers.get("b2b-requestid") || "",
        requestdate:  message.headers.headers.get("date") || "",
      };
    } else if (!isNullOrUndefined(errorType)) {
      message = {
        ...message,
        requestBody: message.stack ? message.stack : message,
        errorType,
      };
    }

    if (message && message.headers){    
      this._LoggerService.createLog(message).subscribe((e)=>{    
        console.log(e)          
      })
    }

  }

  callsWhenError(message) {
    if (_.isArray(message.headers.getAll("date"))) {
      this.requestDate = message.headers.getAll("date")[0];
    } else {
      this.requestDate = "datedate";
    }
  }
  callsWhenIsArray(message) {
    if (_.isArray(message.headers.getAll(COMMON_CONSTANTS.B2B_REQUESTID))) {
      this.b2bRequestid = message.headers.getAll(
        COMMON_CONSTANTS.B2B_REQUESTID
      )[0];
    } else {
      this.b2bRequestid = this._cacheSvc.getFromSessionStorage(
        COMMON_CONSTANTS.HEADER_PROPERTIES.B2B_CLIENT_KEY
      );
    }
  }

  private _prepareUrlProperties(req: HttpRequest<any>) {
    let urlProperties = {};

    if (req.params) {
      urlProperties = req.params.get("metaData");
      req.params.delete("metaData");
    }
    if (req.headers) {
      const metaData = JSON.parse(req.headers.get("metadata") || "{}");
      urlProperties = { ...urlProperties, ...metaData };
    }
    return urlProperties;
  }
}
